import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './layout/main/main.component';
import { HeaderComponent } from './layout/header/header.component';
import { MenuComponent } from './layout/menu/menu.component';
import { PrivateMenuComponent } from './layout/private-menu/private-menu.component';
import { FooterComponent } from './layout/footer/footer.component';
import { ContentComponent } from './layout/content/content.component';
import { MenubarModule } from 'primeng/menubar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
// import { MenuItem } from 'primeng/api';
import { LoginComponent } from './components/login/login.component';
import { FormsModule } from '@angular/forms';
import {TabViewModule} from 'primeng/tabview';
import {MenuModule} from 'primeng/menu';
import { MainPrivateComponent } from './layout/main-private/main-private.component';
import { HeaderPrivateComponent } from './layout/header-private/header-private.component';
import { PanelMenuModule } from 'primeng/panelmenu';
import { TranslateModule } from '@ngx-translate/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { FieldsetModule } from 'primeng/fieldset';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { OlMapComponent } from './components/ol-map/ol-map.component';
import { OlMapMarkerComponent } from './components/ol-map-marker/ol-map-marker.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { DataViewModule } from 'primeng/dataview';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { CaptchaModule } from 'primeng/captcha';
import { OrderListModule } from 'primeng/orderlist';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TableComponent } from './components/table/table.component';
import { ToolbarModule } from 'primeng/toolbar';
import { DialogModule } from 'primeng/dialog';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { CalendarModule } from 'primeng/calendar';
import { ProgressBarModule } from 'primeng/progressbar';
import { FormatPersonalTextPipe } from './pipe/format-personal-text.pipe';
import { ToastComponent } from './components/toast/toast.component';
import { ChartModule } from 'primeng/chart';
import {ChipsModule} from 'primeng/chips';
import { CarouselModule } from 'primeng/carousel';
import {StepsModule} from 'primeng/steps';
import {PasswordModule} from 'primeng/password';
import {EditorModule} from 'primeng/editor';

import { TableAuxComponent } from './components/table-aux/table-aux.component';
import { OlMapPlazasComponent } from './components/ol-map-plazas/ol-map-plazas.component';
import { OlMapBarriosComponent } from './components/ol-map-barrios/ol-map-barrios.component';
import { OlMapPlazaDiponibilidadSemanalComponent } from './components/ol-map-plaza-diponibilidad-semanal/ol-map-plaza-diponibilidad-semanal.component';
import { OlMapZonaVigilanciaComponent } from './components/ol-map-zona-vigilancia/ol-map-zona-vigilancia.component';
import {AutoCompleteModule} from 'primeng/autocomplete';
import { MapBaseLayerSwitcherComponent } from './components/ol-map-plazas/map-base-layer-switcher/map-base-layer-switcher.component';
import { OlMapBaseComponent } from './components/ol-map-base/ol-map-base.component';
import { MapToolbarEditComponent } from './components/ol-map-zona-vigilancia/map-toolbar-edit/map-toolbar-edit.component';
import {AccordionModule} from 'primeng/accordion';
import {MegaMenuModule} from 'primeng/megamenu';

const COMPONENTS = [
  MainComponent,
  HeaderComponent,
  MenuComponent,
  PrivateMenuComponent,
  FooterComponent,
  ContentComponent,
  LoginComponent,
  MainPrivateComponent,
  HeaderPrivateComponent,
  OlMapComponent,
  OlMapMarkerComponent,
  SpinnerComponent,
  TableComponent,
  TableAuxComponent,
  FormatPersonalTextPipe,
  ToastComponent,
  OlMapBaseComponent,
  OlMapPlazasComponent,
  MapBaseLayerSwitcherComponent,
  MapToolbarEditComponent,
  OlMapBarriosComponent,
  OlMapPlazaDiponibilidadSemanalComponent,
  OlMapZonaVigilanciaComponent
];

const MODULES = [
  CommonModule,
  MenuModule,
  MenubarModule,
  InputTextModule,
  ButtonModule,
  FormsModule,
  MenuModule,
  PanelMenuModule,
  TranslateModule,
  FormsModule,
  MultiSelectModule,
  TableModule,
  ConfirmDialogModule,
  ToastModule,
  TooltipModule,
  NgxQRCodeModule,
  FieldsetModule,
  DropdownModule,
  InputNumberModule,
  InputSwitchModule,
  CardModule,
  PanelModule,
  DataViewModule,
  InputTextareaModule,
  FileUploadModule,
  CaptchaModule,
  OrderListModule,
  OverlayPanelModule,
  ToolbarModule,
  ProgressBarModule,
  DialogModule,
  MessageModule,
  MessagesModule,
  DataViewModule,
  CalendarModule,
  ChartModule,
  ProgressBarModule,
  ChipsModule,
  CarouselModule,
  StepsModule,
  PasswordModule,
  TabViewModule,
  AutoCompleteModule,
  EditorModule,
  AccordionModule,
  MegaMenuModule
];

@NgModule({
  declarations: COMPONENTS,
  imports: MODULES,
  exports: [COMPONENTS, MODULES]
})
export class ThemeModule { }
